import { render, staticRenderFns } from "./UnitOccupancyList.vue?vue&type=template&id=17dd966a&scoped=true&"
import script from "./UnitOccupancyList.vue?vue&type=script&lang=js&"
export * from "./UnitOccupancyList.vue?vue&type=script&lang=js&"
import style0 from "./UnitOccupancyList.vue?vue&type=style&index=0&id=17dd966a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd966a",
  null
  
)

export default component.exports